import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function UserSM(): React.ReactElement {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.99979 5.59988C7.58584 5.59988 8.87159 4.3463 8.87159 2.79994C8.87159 1.25358 7.58584 0 5.99979 0C4.41374 0 3.12799 1.25358 3.12799 2.79994C3.12799 4.3463 4.41374 5.59988 5.99979 5.59988Z" />
      <path d="M6.00002 6.40002C3.0593 6.40002 0.666687 8.73276 0.666687 11.5999C0.666687 11.8207 0.850494 11.9999 1.07696 11.9999H10.9231C11.1495 11.9999 11.3334 11.8207 11.3334 11.5999C11.3334 8.73276 8.94074 6.40002 6.00002 6.40002Z" />
    </svg>
  );
}
